import React, { useEffect, useState } from "react";
import "./Edit-Modal.css";

export default function EditModalContact({
  isOpen,
  onClose,
  modalField,
  items = [], // [{id, label, assigned}]
  loading = false,
  onChangeSelected, // (id) => void
  onSave, // () => void
}) {
  const titleMap = {
    contactOwner: "Contact Owner",
    contactMethod: "Contact Method",
    customerType: "Customer Type",
  };

  const [localSelected, setLocalSelected] = useState(null);

  useEffect(() => {
    const assigned = items.find((i) => i.assigned);
    setLocalSelected(assigned ? assigned.id : null);
  }, [items]);

  const handleSelect = (id) => {
    setLocalSelected(id);
    onChangeSelected && onChangeSelected(id);
  };

  if (!isOpen) return null;

  return (
    <div className="edit-modal-overlay">
      <div className="edit-modal-content">
        <div className="edit-modal-header">
          <h2>Select {titleMap[modalField]}</h2>
          <button className="edit-modal-close" onClick={onClose}>✖</button>
        </div>

        <div className="edit-modal-body">
          {loading && <div>Optionen laden…</div>}
          {!loading && items.map((opt) => (
            <label key={opt.id} className="checkbox-option">
              <span>{opt.label}</span>
              <div className="checkbox-wrapper">
                <span className="divider" />
                <input
                  type="radio"
                  name="edit-modal-single"
                  checked={localSelected === opt.id}
                  onChange={() => handleSelect(opt.id)}
                />
              </div>
            </label>
          ))}

          <div className="modal-actions">
            <button className="save-btn" onClick={onSave} disabled={localSelected == null}>Speichern</button>
            <button className="cancel-btn" onClick={onClose}>Abbrechen</button>
          </div>
        </div>
      </div>
    </div>
  );
}

